import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateVaultDialogComponent } from 'app/dialogs/create-vault-dialog/create-vault-dialog.component';
import { VaultService } from 'app/services/models/vault.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-vault-list',
  templateUrl: './vault-list.component.html',
  styleUrls: ['./vault-list.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class VaultListComponent implements OnInit {
  @BlockUI('section-block') blockUI: NgBlockUI;

  constructor(
    private vaultService: VaultService,
    private modalService: NgbModal,
    private router:Router) { }
  vaults: any[] = [];
  totalCount: number;
  public pageBasic = 1;  // Page number
  public selectedSize = 12;  
  async ngOnInit() {
    this.vaultService.event$.subscribe(async result => {
      await this.getAllVault(this.pageBasic - 1, this.selectedSize,'');
    })
    await this.getAllVault(this.pageBasic - 1, this.selectedSize,'');
  }

  showCreateVault() {
    const modal = this.modalService.open(CreateVaultDialogComponent, {
      size: 'ml',
      centered: true,
      windowClass: 'modal modal-success'
    });
    modal.componentInstance.data = null;
  }

  async getAllVault(page, size, search) {
    this.blockUI.start("Hesaplar yükleniyor..");
    const data = await this.vaultService.getAllVault(page, size, search);
    console.log(data);
    this.vaults = data.vaults;
    this.totalCount = data.totalCount;
    this.blockUI.stop();
  }

  showDetail(id){
    this.router.navigate(['/admin/vault-detail/',id])
  }

  async onPageChange(pageNumber: number) {
    this.pageBasic = pageNumber;
    await this.getAllVault(this.pageBasic - 1, this.selectedSize,'');
  }
}
